import { Component } from '@angular/core';
import { Observable } from 'rxjs';

import { GeolocationService } from '../../services/geolocation.service';

@Component({
  selector: 'app-geolocation-loading-overlay',
  templateUrl: './geolocation-loading-overlay.component.html',
  styleUrls: ['./geolocation-loading-overlay.component.scss'],
})
export class GeolocationLoadingOverlayComponent {
  visible$: Observable<boolean>;

  constructor(geolocationService: GeolocationService) {
    this.visible$ = geolocationService.loading$;
  }
}
